/**
 * Header Title Component Constants
 * All magic numbers and configuration values
 */

/**
 * Spacing and Layout Constants
 */
export const HEADER_TITLE_CONSTANTS = {
  /** Gap between main elements in desktop view */
  DESKTOP_GAP: 5,

  /** Gap between content elements in desktop view */
  DESKTOP_CONTENT_GAP: 3,

  /** Gap between elements in mobile view */
  MOBILE_GAP: 4,

  /** Gap between tags in mobile view */
  MOBILE_TAGS_GAP: 3,
} as const;

/**
 * Responsive Breakpoints
 */
export const BREAKPOINTS = {
  /** Desktop breakpoint */
  DESKTOP: 'md',
} as const;

/**
 * Component Configuration
 */
export const COMPONENT_CONFIG = {
  /** Default loading text */
  LOADING_TEXT: 'Loading...',

  /** Tag size */
  TAG_SIZE: 'small',
} as const;
